import { getToken } from '../../utils/auth'

export const loginInfoState = () => ({
  token: getToken() || '',
  loadedUserInfoOnce: false,
})

export const userInfoState = () => ({
  id: localStorage.getItem('user_id') || 0,
  type: localStorage.getItem('user_type') || '',
  accessibleRoutes: [],
  email: localStorage.getItem('user_email') || '',
  name: localStorage.getItem('user_name') || '',
  enabled: localStorage.getItem('user_enabled') || 0,
})
